<template>
  <div
    class="gmp-devices-add-device-form-header"
  >
    <h2 class="gds-font-medium gds-space-stack-ml">
      {{ config.header }}
    </h2>
    <div class="gds-font-book gds-space-stack-s">
      {{ config.summary }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormHeader',
  props: {
    config: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>
